import { Shadow, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Skeleton } from 'native-base';
import React from 'react';

export const CreatingWithdrawal: React.FC = () => {
  return (
    <VStack space={Spacing['stack.xxxs']}>
      <Shadow level={1} padding={Spacing['inset.md']}>
        <VStack space={Spacing['stack.xxxs']}>
          <VStack alignItems="center" space={Spacing['stack.xxxs']}>
            <Skeleton
              height={Spacing['inset.lg']}
              width={Spacing['inset.lg']}
              borderRadius={BoxRadius.sm}
            />
            <Text fontSize={Typography['fontsize.lg']} variant="semibold">
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
            </Text>
          </VStack>
          <VStack
            paddingX={Spacing['inset.sm']}
            paddingY={Spacing['inset.xs']}
            space={Spacing['stack.nano']}
            backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.7)}
            borderRadius={BoxRadius.sm}>
            <HStack justifyContent="space-between" space={Spacing['stack.xs']}>
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
            </HStack>
            <HStack justifyContent="space-between" space={Spacing['stack.xs']}>
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
            </HStack>
            <HStack justifyContent="space-between" space={Spacing['stack.xs']}>
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
              <Skeleton height={Spacing['inset.xs']} borderRadius={BoxRadius.sm} flex={1} />
            </HStack>
          </VStack>
        </VStack>
      </Shadow>
      <HStack justifyContent="space-between" space={Spacing['stack.xs']}>
        <Skeleton height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} flex={1} />
        <Skeleton height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} flex={1} />
      </HStack>
    </VStack>
  );
};
